import React from 'react';

export interface FooterNavLink {
    label: string;
    href?: string;
    onClick?: () => void;
}

export interface FooterNavProps {
    links: FooterNavLink[];
    className?: string;
}

const ITEM_CLASSES =
    'text-[13px] font-medium no-underline text-[var(--malachite-text-placeholder)] hover:text-[var(--malachite-text-secondary)]';

const FooterNav: React.FC<FooterNavProps> = ({ links, className = '' }) => (
    <nav className={`flex items-center justify-center gap-[8px] ${className}`}>
        {links.map((link, index) => (
            <React.Fragment key={`${index}-${link.label}`}>
                {index > 0 && (
                    <span className="text-[13px] text-[var(--malachite-card-border)]">•</span>
                )}
                {link.href ? (
                    <a href={link.href} onClick={link.onClick} className={ITEM_CLASSES}>
                        {link.label}
                    </a>
                ) : (
                    <button
                        type="button"
                        onClick={link.onClick}
                        className={`${ITEM_CLASSES} bg-transparent border-0 cursor-pointer`}
                    >
                        {link.label}
                    </button>
                )}
            </React.Fragment>
        ))}
    </nav>
);

export default FooterNav;
export { FooterNav };
